import { render, staticRenderFns } from "./DoublePendulum.vue?vue&type=template&id=76be6e75&scoped=true&"
import script from "./DoublePendulum.vue?vue&type=script&lang=js&"
export * from "./DoublePendulum.vue?vue&type=script&lang=js&"
import style0 from "./DoublePendulum.vue?vue&type=style&index=0&id=76be6e75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76be6e75",
  null
  
)

export default component.exports